import { LOAD_INBOXES, SUBMIT_INBOX, loadInboxesSuccess } from "../actions/inbox";
import { mapInboxToCard } from "./mapInboxToCard";


export const inbox = {

  [LOAD_INBOXES]: async ({ api, dispatch, getState, action }) => {
    const response = await api.inbox.getInboxes();

    const mappedInboxes = response.data?.map(mapInboxToCard)

    dispatch(loadInboxesSuccess(mappedInboxes))

    return mappedInboxes
  },

  [SUBMIT_INBOX]: async ({ api, dispatch, getState, action }) => {
    const response = await api.inbox.submitInbox(action.payload);
    return response.data
  },


}